/**
 * passiveEvents is a simple object that provides feature detection for passive events, and exports a boolean flag.
 * @link https://github.com/WICG/EventListenerOptions/blob/gh-pages/explainer.md
 */
const passiveEvents = {
    init () {
        this.test()
    },
    supported: false,
    test () {
        try {
            const opts = Object.defineProperty({}, 'passive', {
                get: () => {
                    this.supported = true
                }
            })
            window.addEventListener('test', null, opts)
        } catch (e) {
            // Unsupported, continue on.
        }
    }
}

//  Initialize test.
passiveEvents.init()

export default passiveEvents.supported
